<main>

  <div class="py-5 text-center">
    <h2>建築師</h2>
  </div>

  <div class="pb-4 d-flex">
    <button class="btn btn-outline-primary flex-fill" type="button" (click)="add()">新增建築師</button>
  </div>

  <div class="row g-5">

    <div class="col-12">
      <div class="list-group">
        <a class="list-group-item list-group-item-action"
          *ngFor="let architect of architects | slice: (page-1) * pageSize : page * pageSize"
          routerLink="/backstage/architects/{{architect.ID}}">
          <div class="d-flex">
            <div class="flex-shrink-0">
              <img [src]="getImgSource(architect)" alt="..." class="img-fluid rounded"
                (error) ="onImgError($event)">
            </div>
            <div class="flex-grow-1 ms-3">
              <h5 class="mt-0">{{architect.name.zh}}</h5>
              <p>{{architect.pulitzer ? "普立茲克建築師" : "建築師"}}</p>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="col-12" *ngIf="architects.length > 0">
      <ngb-pagination class="d-flex justify-content-center" [collectionSize]="architects.length" [(page)]="page" [pageSize]="pageSize" [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="onPageChange(page)"></ngb-pagination>
    </div>

    <div class="col-12" *ngIf="architects.length == 0">
      <div class="py-5 text-center">
        <p>正在取得建築師...</p>
      </div>
    </div>

  </div>

</main>

<footer class="my-5 pt-5 text-muted text-center text-small">
  <p class="mb-1">&copy; 2023 PATH LIFE Ltd.</p>
</footer>
